import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  checkSubmenu(router: Router) {
    throw new Error('Method not implemented.');
  }

  public isWrapperActive:boolean;
  constructor(){
      this.isWrapperActive=false;
  }

  
}
